import { createAction, props } from '@ngrx/store';

import { BpasEngagement } from '../../domain/bpas-engagement.model';


export const PAC_LOAD_ENGAGEMENTS_REQUESTED = '[Engagements UI] Load Engagements Requested';
export const PAC_LOAD_ONE_ENGAGEMENT_REQUESTED = '[Engagements UI] Load a specific Engagement Requested';
export const PAC_UPDATE_SELECTED_ENGAGEMENT_ID_REQUESTED = '[Engagements UI] Update a specific Engagement Id Requested';
export const PAC_UPDATE_ENGAGEMENTS_REQUESTED = '[Engagements UI] Update Engagements Requested';
export const PAC_CLOSE_ACTIVE_ENGAGEMENTS_AND_START_NEW_ENGAGEMENT_REQUESTED = '[Engagements UI] Close Active Engagements And Start New Engagement Requested';
export const PAC_UPDATE_ENGAGEMENT_ASYNC_REQUESTED = '[Engagements UI] Update Engagement Async Requested';
export const PAC_ADD_ENGAGEMENT_REQUESTED = '[Engagements UI] Add Engagement Requested';
export const PAC_UPDATE_ENGAGEMENT_LOCALLY = '[Engagements UI] Update Engagement Locally';
export const PAC_REMOVE_PORTFOLIO_FROM_ENGAGEMENT_REQUESTED = '[Engagements UI] Remove Portfolio From Engagement Requested';
export const PAC_NOOP = '[Engagements UI] NoopAction';

export const loadEngagementsRequested = createAction(
	PAC_LOAD_ENGAGEMENTS_REQUESTED
);

export const loadOneEngagementRequested = createAction(
	PAC_LOAD_ONE_ENGAGEMENT_REQUESTED,
	props<{ engagementId: string }>()
);

export const updateSelectedEngagementIdRequested = createAction(
	PAC_UPDATE_SELECTED_ENGAGEMENT_ID_REQUESTED,
	props<{ engagementId: string }>()
);

export const updateEngagementRequested = createAction(
	PAC_UPDATE_ENGAGEMENTS_REQUESTED,
	props<{ mode: string; engagement: BpasEngagement; updateAnalysis: boolean; errorCode: string }>()
);

export const closeActiveEngagementsAndStartNewEngagementRequested = createAction(
	PAC_CLOSE_ACTIVE_ENGAGEMENTS_AND_START_NEW_ENGAGEMENT_REQUESTED,
	props<{ engagements: BpasEngagement[] }>()
);

export const addEngagementRequested = createAction(
	PAC_ADD_ENGAGEMENT_REQUESTED,
	props<{ mode: string; engagement: BpasEngagement }>()
);

export const removePortfolioFromEngagementRequested = createAction(
	PAC_REMOVE_PORTFOLIO_FROM_ENGAGEMENT_REQUESTED,
	props<{ portfolioId: string; engagement: BpasEngagement }>()
);

export const updateEngagementAsyncRequested = createAction(
	PAC_UPDATE_ENGAGEMENT_ASYNC_REQUESTED,
	props<{ mode: string; engagement: BpasEngagement; updateAnalysis: boolean }>()
);

export const engagementsNoop = createAction(
	PAC_NOOP
);
